import FilterWithVacancies from './FilterWithVacancies';
export default FilterWithVacancies;
